/**
 * White-label NODE brand — the ONE source of truth for the node's identity in the React app.
 *
 * WhiteLabelBuddy's premise: the NODE's brand is front and center; AuctionSAAS is the
 * infrastructure underneath. The header, login, and any node-facing chrome read from here.
 *
 * CONFIG-DRIVEN so a new node (Joe, Denlinger, …) is a build setting, not a code change: set
 * the REACT_APP_NODE_* vars per deploy and CRA inlines them at build time (same mechanism as
 * REACT_APP_ACCEPTJS_ENV). Fallbacks below are the current node (Schmidt), so an unset env
 * still renders correctly for schmidt.auctionsaas.com today.
 *
 * NOTE: static files (public/index.html <title>+meta, manifest.json, favicon) are NOT React
 * and can't import this — they're hardcoded to Schmidt for now; per-node templating of those
 * is the logged follow-up (see the dispatch report).
 */
export interface NodeBrand {
  /** Header wordmark, all-caps (e.g. "SCHMIDT AUCTIONS"). */
  name: string;
  /** Sentence-case display name for prose (e.g. "Schmidt Auctions"). */
  displayName: string;
  /** Tagline under the wordmark. */
  tagline: string;
  /** Auctioneer license number, kept legible. */
  license: string;
}

export const BRAND: NodeBrand = {
  name: process.env.REACT_APP_NODE_NAME || 'SCHMIDT AUCTIONS',
  displayName: process.env.REACT_APP_NODE_DISPLAY_NAME || 'Schmidt Auctions',
  tagline: process.env.REACT_APP_NODE_TAGLINE || 'Online Estate Sales & Collection Breaks.',
  license: process.env.REACT_APP_NODE_LICENSE || 'AU#006176',
};
